/**
 * Copyright (c) Qwoach LLC 2021. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 11.02.21
 *
 */
export const env = process.env.NODE_ENV

export const isDevEnv = env === "development"
export const isProdEnv = env === "production"
